import * as React from 'react';

function SvgEmojiSmileUpsideDown(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 1a7 7 0 100 14A7 7 0 008 1zm0-1a8 8 0 110 16A8 8 0 018 0z' />
			<path d='M4.285 6.433a.5.5 0 00.683-.183A3.498 3.498 0 018 4.5c1.295 0 2.426.703 3.032 1.75a.5.5 0 00.866-.5A4.498 4.498 0 008 3.5a4.5 4.5 0 00-3.898 2.25.5.5 0 00.183.683zM7 9.5C7 8.672 6.552 8 6 8s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5zm4 0c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5.448 1.5 1 1.5 1-.672 1-1.5z' />
		</svg>
	);
}

export default SvgEmojiSmileUpsideDown;
